import { render, staticRenderFns } from "./PhienBanForm.vue?vue&type=template&id=407b2924&"
import script from "./PhienBanForm.vue?vue&type=script&lang=js&"
export * from "./PhienBanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports